/**
 *
 * FlashCardLandingCourseCpnt
 *
 */

import { mapState, mapGetters } from 'vuex';

import Spinner from '@/components/Spinner.vue';
import MainModeFlashCardBook from '@/views/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardBook.vue';
import MainModeFlashCardFavorite from '@/views/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardFavorite.vue';
import { GetCourseFlashCardListMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/GetCourseFlashCardListMixin';

export default {
  name: 'MainModeFlashCardLanding',

  mixins: [GetCourseFlashCardListMixin],

  components: {
    Spinner,
    MainModeFlashCardBook,
    MainModeFlashCardFavorite,
  },

  computed: {
    ...mapState('MainModeCourse', {
      MainModeCourse_ms_isRequest: 'isRequest',
    }),

    ...mapState('FlashCard/FlashCardLanding', {
      FlashCardLanding_ms_isRequest: 'isRequest',
    }),

    ...mapGetters('FlashCard/FlashCardLanding', {
      mg_flashCardList: 'flashCardList',
      mg_isFlashCardUnpaid: 'isFlashCardUnpaid',
      mg_isFlashCardWaiting: 'isFlashCardWaiting',
      mg_isFlashCardAvailable: 'isFlashCardAvailable',
    }),

    c_isCpntRequest() {
      return !this.MainModeCourse_ms_isRequest && this.FlashCardLanding_ms_isRequest;
    },
  },
};
